// extracted by mini-css-extract-plugin
export var externalLink = "_db-0";
export var internalLinkLabel = "_db-1";